export const groupDataByKeys = (dataToGroup, depth, dateGroupingFunctions, rowDateKeyExtractor) => {
    const isDepthExceeded = depth >= dateGroupingFunctions.length;
    if (isDepthExceeded) {
        return dataToGroup;
    }
    const groupingFunction = dateGroupingFunctions[depth];
    if (!groupingFunction) {
        return dataToGroup;
    }
    const groupedData = dataToGroup.reduce((acc, row) => {
        const dateKey = rowDateKeyExtractor(row);
        const key = groupingFunction(dateKey);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(row);
        return acc;
    }, {});
    return groupedData;
};
